module.exports = __webpack_public_path__ + "img/mimg1.231cc36d.png";